export default __webpack_public_path__ + "685bedb26bd61994c424fea86500a354.png";